import { GlBadge } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import TierBadgePopover from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/vue_shared/components/tier_badge/tier_badge_popover.vue?vue3';
export default {
    name: 'TierBadge',
    components: {
        GlBadge,
        TierBadgePopover
    },
    mixins: [
        Tracking.mixin({
            label: 'tier_badge'
        })
    ],
    props: {
        tier: {
            type: String,
            required: false,
            default: s__('TierBadge|Free')
        }
    },
    data: ()=>({
            target: undefined
        }),
    mounted () {
        this.trackRender();
        this.target = this.$refs.badge?.$el;
    },
    methods: {
        trackRender () {
            this.track('render_badge');
        },
        trackHover () {
            this.track('render_flyout');
        }
    }
};
